import React, { FunctionComponent } from "react";
import { Demo } from "../components/demo";
import { ComponentProps } from "../components/component-props";

const radioButtonCode = `<RadioButtonGroup header="Group 1" name="group1">
    <RadioButton value="value1">Click me!</RadioButton>
    <RadioButton value="value2">Click me!</RadioButton>
</RadioButtonGroup>`;

const radioButtonDemo = {
    code: radioButtonCode
};

export const RadioButtonDemo: FunctionComponent = () => {
    return (
        <Demo demo={radioButtonDemo}>
            <ComponentProps componentName="RadioButtonGroup" />
            <ComponentProps componentName="RadioButton" />
        </Demo>
    );
};
